<template>
  <div>
    <v-data-table
      :items="items"
      :headers="headers"
      :pagination.sync="localPagination"
      :total-items="localPagination.totalItems"
      :loading="loading"
      disable-initial-sort
      hide-actions
      @update:pagination="() => emitPagination()"
    >
      <template #items="{ item }">
        <td class="text-xs-right">{{ item.index }}</td>
        <td class="text-xs-right">{{ item.brokerId || '-' }}</td>
        <td>{{ item.brokerName || '-' }}</td>
        <td>{{ item.province || '-' }}</td>
        <td>{{ item.district || '-' }}</td>
        <td>{{ item.channel || '-' }}</td>
        <td>{{ item.status || '-' }}</td>
        <td>{{ item.date | DateFormat('DD/MM/YYYY') }}</td>
        <td>
          <v-btn icon small outline color="primary" @click="$emit('view', item)">
            <v-icon small>visibility</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-layout v-if="totalPages > 0" class="mt-3">
      <v-spacer />
      <v-pagination
        v-model="localPagination.page"
        :length="totalPages"
        :total-visible="9"
        class="ml-auto"
        @input="() => emitPagination()"
      />
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localPagination: {
        page: 1,
        totalItems: 0,
        rowsPerPage: 10,
        ...this.pagination
      },
      headers: [
        { value: 'index', text: this.$t('no.'), sortable: false, align: 'right' },
        {
          value: 'brokerId',
          text: this.$t('asset_wise.broker_id'),
          sortable: false,
          align: 'right'
        },
        { value: 'brokerName', text: this.$t('asset_wise.broker_name'), sortable: false },
        { value: 'province', text: this.$t('Province'), sortable: false },
        { value: 'district', text: this.$t('asset_wise.district'), sortable: false },
        { value: 'channel', text: this.$t('Channel'), sortable: false },
        { value: 'status', text: this.$t('Status'), sortable: false },
        { value: 'date', text: this.$t('Date'), sortable: false },
        { sortable: false }
      ],
      hasInit: false
    }
  },
  computed: {
    totalPages() {
      const { totalItems, rowsPerPage } = this.localPagination
      return Math.ceil(totalItems / rowsPerPage)
    }
  },
  watch: {
    pagination(value) {
      this.localPagination = { ...this.localPagination, ...value }
    }
  },
  methods: {
    emitPagination() {
      if (!this.hasInit) {
        this.hasInit = true
        return
      }
      this.$emit('update:pagination', this.localPagination)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/LandSale/DataTable.vue